import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Destination, OldDestination } from '../models/destination.model';
import { RestUtils } from './rest-utils';

@Injectable()
export class DestinationsService {
  utils = new RestUtils();

  headers = new HttpHeaders();

  constructor(
    @Inject('NETWORKS_ONLINE_URL') private networksOnlineUrl: string,
    @Inject('NETWORK_UPDATES_URL') private networkUpdatesUrl: string,
    @Inject('NETWORKS_ONLINE_RCS_URL') private networksOnlineRcsUrl: string,
    @Inject('NETWORK_UPDATES_RCS_URL') private networkUpdatesRcsUrl: string,
    @Inject('NETWORKS_ONLINE_FLASH_CALL_URL') private networksOnlineFlashCallUrl: string,
    @Inject('NETWORK_UPDATES_FLASH_CALL_URL') private networkUpdatesFlashCallUrl: string,
    @Inject('MO_NETWORKS_ONLINE_URL') private moNetworksOnlineUrl: string,
    @Inject('MO_NETWORK_UPDATES_URL') private moNetworkUpdatesUrl: string,
    @Inject('VOICE_NETWORKS_ONLINE_URL') private voiceNetworksOnlineUrl: string,
    @Inject('VOICE_NETWORK_UPDATES_URL') private voiceNetworkUpdatesUrl: string,
    private http: HttpClient
  ) {
    this.headers = this.headers.set('Content-Type', 'application/json');
  }

  online(): Observable<Destination[]> {
    return this.http.get<OldDestination[]>(this.networksOnlineUrl).pipe(map(d => d.map(_ => this.mapToDestination(_))));
  }

  onlineRcs(): Observable<Destination[]> {
    return this.http.get<OldDestination[]>(this.networksOnlineRcsUrl).pipe(map(d => d.map(_ => this.mapToDestination(_))));
  }

  onlineFlashCall(): Observable<Destination[]> {
    return this.http.get<OldDestination[]>(this.networksOnlineFlashCallUrl).pipe(map(d => d.map(_ => this.mapToDestination(_))));
  }

  moOnline(): Observable<Destination[]> {
    return this.http.get<OldDestination[]>(this.moNetworksOnlineUrl).pipe(map(d => d.map(_ => this.mapToDestination(_))));
  }

  voiceOnline(): Observable<Destination[]> {
    return this.http.get<OldDestination[]>(this.voiceNetworksOnlineUrl).pipe(map(d => d.map(_ => this.mapToDestination(_))));
  }

  getNetworkUpdatesUrl(): string {
    return this.networkUpdatesUrl;
  }

  getNetworkUpdatesRcsUrl(): string {
    return this.networkUpdatesRcsUrl;
  }

  getNetworkUpdatesFlashCallUrl(): string {
    return this.networkUpdatesFlashCallUrl;
  }

  getMoNetworkUpdatesUrl(): string {
    return this.moNetworkUpdatesUrl;
  }

  getVoiceNetworkUpdatesUrl(): string {
    return this.voiceNetworkUpdatesUrl;
  }

  mapToDestination(destination: OldDestination): Destination {
    return {
      mcc: destination.mcc,
      countryName: destination.country,
      mnc: destination.mnc,
      providerName: destination.provider,
      originalMnc: destination.original_mnc,
      originalProviderName: destination.original_provider,
    };
  }

  getFavourites(): Observable<Destination[]> {
    const url = this.utils.buildUrl('ROLE/usr/destination-favourites');
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.get<Destination[]>(url, options);
  }

  createFavorite(destination: Destination): Observable<any> {
    const url = this.utils.buildUrl('ROLE/usr/destination-favourites');
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.post(url, destination, options);
  }

  deleteFavorite(mcc: string, mnc: string, originalMnc?: string): Observable<any> {
    const queryParams = { mcc: mcc, mnc: mnc, originalMnc: originalMnc };
    const url = this.utils.buildUrl('ROLE/usr/destination-favourites', queryParams);
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.delete(url, options);
  }
}
